import { CSSProperties, useState } from "react";
import { projects, ProjectId } from "../data/projects";

const statements: Record<ProjectId, string> = {
  tracker: "A clearer picture of your money.",
  counter: "Everyday nutrition, in perspective.",
  spotter: "Plan your training. Build on every set.",
};

export function ProductFamily() {
  const [focused, setFocused] = useState<ProjectId | null>(null);
  return (
    <section
      id="work"
      className="family-section"
      aria-labelledby="work-heading"
      data-focus={focused || "none"}
    >
      <div className="family-ambient" aria-hidden="true" />
      <div className="wrap family-content">
        <div className="family-heading">
          <p className="micro">01 / SELECTED WORK</p>
          <h2 id="work-heading">
            Three products
            <br />
            <span>I’m building.</span>
          </h2>
          <p>Everyday problems. Carefully considered tools.</p>
        </div>
        <div className="family-products" onMouseLeave={() => setFocused(null)}>
          {projects.map((project, index) => (
            <a
              className={`family-product family-${project.id}`}
              href={`#${project.id}`}
              key={project.id}
              style={{ "--family-order": index } as CSSProperties}
              onMouseEnter={() => setFocused(project.id)}
              onFocus={() => setFocused(project.id)}
              onBlur={() => setFocused(null)}
              onPointerMove={(event) => {
                if (
                  event.pointerType !== "mouse" ||
                  window.matchMedia("(prefers-reduced-motion: reduce)").matches
                )
                  return;
                const box = event.currentTarget.getBoundingClientRect();
                event.currentTarget.style.setProperty(
                  "--icon-x",
                  `${((event.clientX - box.left) / box.width - 0.5) * 8}px`
                );
                event.currentTarget.style.setProperty(
                  "--icon-y",
                  `${((event.clientY - box.top) / box.height - 0.5) * 6}px`
                );
              }}
              onPointerLeave={(event) => {
                event.currentTarget.style.setProperty("--icon-x", "0px");
                event.currentTarget.style.setProperty("--icon-y", "0px");
              }}
            >
              <div className="family-icon-stage">
                <span className="family-orbit" aria-hidden="true" />
                <img
                  src={project.icon}
                  alt=""
                  width="384"
                  height="384"
                  loading="lazy"
                />
              </div>
              <span className="micro family-category">
                0{index + 1} / {project.category}
              </span>
              <h3>{project.name}</h3>
              <p>{statements[project.id]}</p>
              <span className="family-explore">
                Explore {project.name}
                <span aria-hidden="true">↘</span>
              </span>
            </a>
          ))}
        </div>
        <p className="family-authorship">
          Designed and built by me, from the interface to the underlying logic.
        </p>
      </div>
    </section>
  );
}
